import styled from 'styled-components';

const FormDetailText = styled.p`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 14px;
  color: rgba(0, 20, 77, 0.6);
`;

export default FormDetailText;



// WEBPACK FOOTER //
// ./src/components/FormComponents/FormDetailText.tsx